import { MediaPicker } from '@customTypes/mediaPicker'
import useWindowDimensions from '@lib/hooks/useWindowDimensions'
import { UmbracoMediaFragment } from '@lib/umbraco/generated/types.generated'
import { useEffect, useState } from 'react'

const useMediaPicker = (mediaPicker: MediaPicker) => {
  const [media, setMedia] = useState<Partial<UmbracoMediaFragment>>(
    mediaPicker?.media,
  )
  const { width } = useWindowDimensions()

  useEffect(() => {
    if (width < 750 && mediaPicker?.media) {
      if (
        mediaPicker.media.__typename === 'Image' &&
        mediaPicker.media.mobileImage
      )
        return setMedia(mediaPicker.media.mobileImage.media)
      if (
        mediaPicker.media.__typename === 'UmbracoMediaVideo' &&
        mediaPicker.media.mobileVideo
      )
        return setMedia(mediaPicker.media.mobileVideo.media)
    }
    setMedia(mediaPicker?.media)
  }, [width])

  return media
}

export default useMediaPicker
